import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../../common/SafeIcon';
import api from '../../../services/api';

export default function Subscriptions() {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    api.getPublicPlans()
      .then(res => setPlans(res.plans || []))
      .catch(err => console.error('Error loading plans:', err));
  }, []);

  if (plans.length === 0) return null;

  return (
    <section className="py-[100px] bg-[#030509] border-t border-[#242832]">
      <div className="w-[calc(100%-40px)] md:w-[calc(100%-64px)] max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <span className="text-[11px] font-bold tracking-[0.2em] text-[#2F6BFF] uppercase mb-4 block">
              Continuous Intelligence Retainers
            </span>
            <h2 className="text-[clamp(32px,3.5vw,48px)] font-semibold text-white leading-[1.1] tracking-[-0.035em]">
              Stay informed beyond the campaign.
            </h2>
          </div>
          <Link to="/plans" className="text-[13px] font-bold uppercase tracking-[0.1em] text-[#2F6BFF] hover:text-white transition-colors">
            Compare All Plans & Add-ons →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan) => (
            <div 
              key={plan.id}
              className={`rounded-2xl p-8 border flex flex-col justify-between transition-all duration-300 ${
                plan.popular 
                  ? 'bg-[#0B0C0F] border-[#2F6BFF] shadow-2xl shadow-[#2F6BFF]/10 relative' 
                  : 'bg-[#050506] border-[#242832] hover:border-zinc-700'
              }`}
            >
              <div>
                {plan.popular && (
                  <span className="bg-[#2F6BFF] text-white text-[9px] font-bold px-3 py-1 rounded-full uppercase tracking-widest mb-4 inline-block">
                    Most Popular
                  </span>
                )}
                <h3 className="text-2xl font-serif font-bold text-white mb-2">{plan.name}</h3>
                <p className="text-xs text-[#A7ADB8] leading-relaxed mb-6 h-10">{plan.description}</p>
                
                <div className="mb-8 pb-6 border-b border-[#242832]">
                  <span className="text-3xl font-bold text-white">{plan.price}</span>
                  <span className="text-xs text-zinc-500 uppercase tracking-wider ml-2">/ month</span>
                </div>

                <ul className="space-y-3 mb-8">
                  {plan.features.slice(0, 5).map((f, i) => (
                    <li key={i} className="flex gap-3 text-xs text-zinc-300">
                      <SafeIcon name="Check" className="w-3.5 h-3.5 text-[#2F6BFF] shrink-0 mt-0.5" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Link 
                to="/request-review" 
                className={`w-full py-4 rounded-xl font-bold uppercase tracking-widest text-[11px] text-center transition-all ${
                  plan.popular 
                    ? 'bg-[#2F6BFF] hover:bg-[#1a54ff] text-white shadow-lg shadow-[#2F6BFF]/20' 
                    : 'bg-white hover:bg-zinc-200 text-[#030509]'
                }`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}